import { Typography } from "@material-ui/core"
import styled from 'styled-components';

export const HeaderText = styled(Typography)(() => ({
	marginBottom: 16
}))